import { useState } from 'react';
import { toast } from 'react-toastify';
import { getCultureCampaignKey } from 'utils/Datagrid/CustomParcelstDataGridUtils';

const useMapData = (suggest, setSuggest, exploitationParcels, forecastCampaign, setHasChange) => {
  const [mapTab, setMapTab] = useState(false);
  const [mapYear, setMapYear] = useState(null);
  const [modalMap, setModalMap] = useState(false);
  const [editData, setEditData] = useState(null);

  const parcelContextData = (selectedParcel, isChildrenParcel = false) => {
    const referenceParcel = exploitationParcels?.find((parcel) => parcel.id === selectedParcel.id);
    const referenceParcelCultureNOrganicState =
      referenceParcel && suggest?.previous
        ? (suggest.previous?.cropGrossMargin?.[0]?.find(
            (crop) => crop?.culture?.id === referenceParcel?.previousCulture1?.id,
          )?.culture?.organicState ?? null)
        : null;

    let isGroupedParcel = false;
    let groupSurface = 0;
    let groupChildrenParcels = [];
    let cultures = [];

    if (selectedParcel?.hasOwnProperty('isParent') && selectedParcel?.isParent === true) {
      isGroupedParcel = true;
      groupSurface = selectedParcel?.surface;
      groupChildrenParcels = exploitationParcels
        ?.filter((parcel) => parcel?.parent === selectedParcel?.id)
        .map((parcel) => parcel?.id);
    }

    if (selectedParcel?.hasOwnProperty('parent')) {
      isGroupedParcel = true;
      groupSurface = suggest?.parcels?.find(
        (parcel) => parcel?.id === selectedParcel?.parent,
      )?.surface;
      groupChildrenParcels = exploitationParcels
        ?.filter((parcel) => parcel?.parent === selectedParcel?.parent)
        .map((parcel) => parcel?.id);
      cultures = suggest?.parcels.find((parcel) => parcel?.id === selectedParcel?.parent)?.cultures;
    }

    let selectedParcelData = {
      ...selectedParcel,
      coordinates: exploitationParcels ? referenceParcel?.coordinates : 'Pas de culture à afficher',
      previousCulture1: {
        name: exploitationParcels
          ? referenceParcel?.parcelCultures[getCultureCampaignKey(1, forecastCampaign)]?.name
          : 'Pas de culture à afficher',
        id: exploitationParcels
          ? referenceParcel?.parcelCultures[getCultureCampaignKey(1, forecastCampaign)]?.id
          : '',
        isIrrigable: exploitationParcels ? referenceParcel?.previousCulture1?.isIrrigable : false,
        year: forecastCampaign?.startYear - 1,
        organicState: referenceParcelCultureNOrganicState,
      },
      previousCulture2: {
        name: exploitationParcels
          ? referenceParcel?.parcelCultures[getCultureCampaignKey(2, forecastCampaign)]?.name
          : 'Pas de culture à afficher',
        id: exploitationParcels
          ? referenceParcel?.parcelCultures[getCultureCampaignKey(2, forecastCampaign)]?.id
          : '',
        year: forecastCampaign?.startYear - 2,
      },
      groundType: {
        name: exploitationParcels ? referenceParcel?.groundType?.name : 'Pas de culture à afficher',
        id: exploitationParcels ? referenceParcel?.groundType?.id : '',
      },
      isIrrigableOnly: exploitationParcels ? referenceParcel?.isIrrigable : false,
      surface: exploitationParcels ? referenceParcel?.surface : 'inconnu',
      isGroupedParcel,
      organicState: exploitationParcels ? referenceParcel?.organicState : '',
    };

    if (isGroupedParcel) {
      selectedParcelData = {
        ...selectedParcelData,
        groupChildrenParcels: groupChildrenParcels ?? [],
        groupSurface: groupSurface ?? 'inconnu',
      };

      if (isChildrenParcel) {
        selectedParcelData.cultures = cultures ?? [];
      }
    }

    return selectedParcelData;
  };

  const getMapParcelsData = () => {
    if (!suggest?.parcels) return [];

    const parcels = suggest.parcels.map((selectedParcel) => parcelContextData(selectedParcel));

    const childrenParcels = exploitationParcels
      ?.filter(
        (parcel) =>
          parcel.hasOwnProperty('parent') &&
          suggest.parcels.some((parcelle) => parcelle?.id === parcel?.parent) &&
          !suggest.parcels.some((parcelle) => parcelle?.id === parcel?.id),
      )
      .map((childrenParcel) => parcelContextData(childrenParcel, true));

    return [...parcels, ...(childrenParcels ?? [])];
  };

  function setModalData(parcelToUpdate, parcelYear, minYear) {
    if (parcelYear === minYear) {
      toast.warning(`La campagne en cours n'est pas modifiable`, {
        toastId: 'warning',
      });
    } else {
      if (parcelToUpdate?.isParent) {
        let groupParcelNames = exploitationParcels
          ?.filter((parcel) => parcelToUpdate?.groupChildrenParcels?.includes(parcel?.id))
          ?.map((childrenParcel) => childrenParcel.name);
        parcelToUpdate = { ...parcelToUpdate, groupParcelNames: groupParcelNames };
      }
      setEditData(parcelToUpdate);
      setModalMap(true);
    }
  }

  const updateFromMap = (parcelId, updatedCultures, year) => {
    const updatedSuggest = structuredClone(suggest);
    const foundParcel = updatedSuggest.parcels.find((parcel) => parcel.id === parcelId);
    if (foundParcel) {
      const yearIndex = year - forecastCampaign?.startYear;
      if (yearIndex >= 0 && yearIndex < foundParcel.cultures.length) {
        foundParcel.cultures[yearIndex] = updatedCultures;
      }
    }
    setSuggest(updatedSuggest);
    setModalMap(false);
    setHasChange(true);
  };

  return {
    mapTab,
    setMapTab,
    mapYear,
    setMapYear,
    modalMap,
    setModalMap,
    editData,
    getMapParcelsData,
    setModalData,
    updateFromMap,
  };
};

export default useMapData;
